import {Component, Input, OnInit} from '@angular/core';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';

import {PropertiesService} from '@core/services/properties.service';
import {CustomEventService} from '@shared/services/custom-event.service';

import ActionTypesEnum from '@shared/enums/action-constant.enum';

import {validateFormGroup} from '@shared/utils/form.util';
import {addonList} from '@shared/variables/datasources.variables';
import {AdminService} from '@shared/services/admin.service';
import {DatasourceService} from '@shared/services/datasource.service';

@Component({
  selector: 'app-add-datasource-modal',
  templateUrl: './add-datasource-modal.component.html'
})
export class AddDatasourceModalComponent implements OnInit {

  @Input() addOn: any;
  @Input() dataSource: any;
  @Input() loading: boolean;
  @Input() testLoading: boolean;
  @Input() testConnectionResult: boolean;
  @Input() testConnectionFailed: string;

  addForm: FormGroup;
  editMode = false;
  versions: any;
  testConnectionDone = false;
  addonData: any;
  authWithGithub = false;
  visiableGithubAppInfo = false;

  constructor(
    private fb: FormBuilder,
    private customEventService: CustomEventService,
    public propertiesService: PropertiesService,
    private adminService: AdminService,
    private datasourceService: DatasourceService) { }

  ngOnInit(): void {
    this.testConnectionDone = false;
    this.editMode = !!this.dataSource;

    this.updateForm();
    this.addonData = this.addOn.name === "AzureApplicationInsights" ? addonList.filter(item => item.name === this.addOn.displayName) : addonList.filter(item => item.name === this.addOn.name);
    // manually created the values of the selection box
    if (this.addOn.versions) {
      this.versions = this.addOn.versions?.map(item => {
        return {
          label: `${this.addOn.name} ${item.value}`,
          value: item.key
        }
      });
    }
  }

  setAsDefaultChanged(event: any): void {
    const isChecked = event.target.checked;

    if (isChecked) {
      this.addForm.get('defaultDataSource').setValue(true);
    } else {
      this.addForm.get('defaultDataSource').setValue(false);
    }
  }

  submitForm(): void {
    const formData = this.addForm.value;

    if (this.addOn.name === 'Veracode') {
      formData.defaultDataSource = this.addForm.get('defaultDataSource').value;
    } else if (this.addOn.name === 'Sonar' || this.addOn.name === 'SonarCloud') {
      delete formData.defaultDataSource;
    }

    if (this.propertiesService.PLAYGROUND) {
      return;
    }

    if (this.addOn.distributionType === 'CLOUD' || this.addOn.authType === 'API_KEY_AND_APP_ID') {
      this.addForm.get('url').setValidators(null);
    }

    validateFormGroup(this.addForm);

    if (this.addForm.invalid) {
      return;
    }


    if (this.addOn.name === 'Veracode') {
      formData.defaultDataSource = this.addForm.get('defaultDataSource').value;
    } else if (this.addOn.name === 'Sonar' || this.addOn.name === 'SonarCloud') {
      delete formData.defaultDataSource;
    }

    if (this.addOn.distributionType === 'CLOUD' || this.addOn.authType === 'API_KEY_AND_APP_ID') {
      delete formData.url;
    }

    formData.version = this.addOn.versions.find(item => item.key === formData.version)?.value;

    this.customEventService.announceEvent(this.editMode ? ActionTypesEnum.EDIT_DATASOURCE : ActionTypesEnum.ADD_DATASOURCE, {dataSource: formData, addOn: this.addOn});
  }

  resetForm(): void {
    this.updateForm();
  }

  cancelForm(): void {
    this.customEventService.announceEvent(ActionTypesEnum.CANCEL_DATASOURCE_DETAIL);
  }

  updateForm(): void {
    const dataSource = this.dataSource;

    if (this.dataSource) {
      this.editMode = true;
      this.authWithGithub = this.dataSource.version === 'OOBEYA_GITHUB_APP' || this.dataSource.version === 'OWN_GITHUB_APP';
      this.visiableGithubAppInfo = this.dataSource.version === 'OWN_GITHUB_APP';
      this.addForm = this.fb.group({
        name: [dataSource.name, [Validators.required]],
        addonId: [this.addOn.id, [Validators.required]],
        url: [dataSource.url, [Validators.required]],
        id: [dataSource.id, [Validators.required]],
        authType: [this.addOn.authType, [Validators.required]],
        version: [dataSource.version ? dataSource.version : null],
        defaultDataSource: [dataSource.defaultDataSource ? dataSource.defaultDataSource : false]
      });
      if (this.visiableGithubAppInfo) {
        this.addForm.addControl('authInfo', this.fb.group({
          clientId: [dataSource.authInfo?.clientId ? dataSource.authInfo.clientId : null, [Validators.required]],
          clientSecret: [dataSource.authInfo?.clientSecret ? dataSource.authInfo.clientSecret: null, [Validators.required]]
        }));
      }

      if (this.addOn.authType === 'BASIC_AUTH' && this.addOn.name !== "AppDynamics") {
        this.addForm.addControl('authInfo', this.fb.group({
          username: [dataSource.authInfo.username, [Validators.required]],
          password: [dataSource.authInfo.password, [Validators.required]],
          authTokenType: [dataSource.authInfo.authTokenType, [Validators.required]]
        }));
      } else if (this.addOn.authType === 'BASIC_AUTH' && this.addOn.name === "AppDynamics") {
        this.addForm.addControl('authInfo', this.fb.group({
          username: [dataSource.authInfo.username, [Validators.required]],
          accountName: [dataSource.authInfo.accountName, [Validators.required]],
          password: [dataSource.authInfo.password, [Validators.required]]
        }));
      }else if (this.addOn.authType === 'CLOUD_BASIC_AUTH') {
        this.addForm.addControl('authInfo', this.fb.group({
          username: [dataSource.authInfo.username, [Validators.required]],
          password: [dataSource.authInfo.password, [Validators.required]],
          workspace: [dataSource.authInfo.workspace, [Validators.required]]
        }));
      } else if (this.addOn.authType === 'USERNAME_TOKEN') {
        this.addForm.addControl('authInfo', this.fb.group({
          username: [dataSource.authInfo.username, [Validators.required]],
          token: [dataSource.authInfo.token, [Validators.required]]
        }));
      } else if (this.addOn.authType === 'FULL_AUTH') {
        this.addForm.addControl('authInfo', this.fb.group({
          username: [dataSource.authInfo.username, []],
          password: [dataSource.authInfo.password, []],
          token: [dataSource.authInfo.token, [Validators.required]]
        }));
      }
      else if (this.addOn.authType === 'API_KEY_AND_APP_ID') {
        this.addForm.addControl('authInfo', this.fb.group({
          applicationId: [dataSource.authInfo.applicationId, [Validators.required]],
          apiKey: [dataSource.authInfo.apiKey, [Validators.required]],
        }));
      }
      else if (this.addOn.authType === 'API_KEY') {
        this.addForm.addControl('authInfo', this.fb.group({
          accessKey: [dataSource.authInfo.accessKey, [Validators.required]],
          secretKey: [dataSource.authInfo.secretKey, [Validators.required]]
        }));
      }
      else {
        this.addForm.addControl('authInfo', this.fb.group({
          token: [dataSource.authInfo.token, this.addOn.displayName !== 'SonarQube' && !this.addOn.custom ? [Validators.required] : null],
          queryKey: [dataSource.authInfo.queryKey, this.addOn.name === 'NewRelic' ? [Validators.required] : null],
          organization: [dataSource.authInfo.organization, this.addOn.name === 'SonarCloud' ? [Validators.required] : null],
        }));
      }

    } else {
      this.addForm = this.fb.group({
        name: [null, [Validators.required]],
        addonId: [this.addOn.id, [Validators.required]],
        url: [null, [Validators.required]],
        authType: [this.addOn.authType, [Validators.required]],
        version: [this.addOn.versions[0]?.key? this.addOn.versions[0]?.key: null],
        defaultDataSource: [false]
      });

      if (this.addOn.authType === 'API_KEY_AND_APP_ID') {
        this.addForm.get('url').setValidators(null);
      }

      if (this.addOn.authType === 'BASIC_AUTH' && this.addOn.name !== "AppDynamics") {
        this.addForm.addControl('authInfo', this.fb.group({
          username: [null, [Validators.required]],
          password: [null , [Validators.required]],
          authTokenType: ['BASIC', [Validators.required]]
        }));
      }  else if (this.addOn.authType === 'BASIC_AUTH' && this.addOn.name === "AppDynamics") {
        this.addForm.addControl('authInfo', this.fb.group({
          username: [null, [Validators.required]],
          accountName: ['customer1', [Validators.required]],
          password: [null, [Validators.required]],
        }));
      } else if (this.addOn.authType === 'CLOUD_BASIC_AUTH') {
        this.addForm.addControl('authInfo', this.fb.group({
          username: [null, [Validators.required]],
          password: [null, [Validators.required]],
          workspace: [null, [Validators.required]]
        }));
      } else if (this.addOn.authType === 'USERNAME_TOKEN') {
        this.addForm.addControl('authInfo', this.fb.group({
          username: [null, [Validators.required]],
          token: [null, [Validators.required]]
        }));
      } else if (this.addOn.authType === 'FULL_AUTH') {
        this.addForm.addControl('authInfo', this.fb.group({
          username: [null, []],
          password: [null, []],
          token: [null, [Validators.required]]
        }));
      }
      else if (this.addOn.authType === 'API_KEY_AND_APP_ID') {
        this.addForm.addControl('authInfo', this.fb.group({
          applicationId: [null, [Validators.required]],
          apiKey: [null, [Validators.required]]
        }));
      }
      else if (this.addOn.authType === 'API_KEY') {
        this.addForm.addControl('authInfo', this.fb.group({
          accessKey: [null, [Validators.required]],
          secretKey: [null, [Validators.required]]
        }));
      }
      else {
        this.addForm.addControl('authInfo', this.fb.group({
          token: [null, this.addOn.displayName !== 'SonarQube' && !this.addOn.custom ? [Validators.required] : null],
          queryKey: [null, this.addOn.name === 'NewRelic' ? [Validators.required] : null],
          organization: [null, this.addOn.name === 'SonarCloud' ? [Validators.required] : null],
          clientId: [null, this.visiableGithubAppInfo ? [Validators.required] : null],
          clientSecret: [null,  this.visiableGithubAppInfo ? [Validators.required] : null]
        }));
      }
    }
  }

  changeVersion(event) {
    this.authWithGithub = event === 'OOBEYA_GITHUB_APP' || event === 'OWN_GITHUB_APP';
    this.visiableGithubAppInfo = event === 'OWN_GITHUB_APP';
    if(this.dataSource) {
      this.dataSource['version'] = event;
      this.updateForm();
    }

  }

  async requestGitHubPermission() {
    if(this.addForm.valid) { return; }
    const { name, id, version} = this.addForm.value;
    const clientId = this.addForm.controls['authInfo']?.value?.clientId;
    const clientSecret = this.addForm.controls['authInfo']?.value?.clientSecret;
    const oobeyaClientId =  "Iv1.c9c43519eec9650b";
    const serverSettingsResponse = await this.adminService.getSettings('server').toPromise();
    const baseUrl = serverSettingsResponse.settings.server;
    const request = {
      'datasourceId': id,
      'datasourceName': name,
      'version': version,
      'clientId': this.visiableGithubAppInfo ? clientId : oobeyaClientId,
      'clientSecret': clientSecret
    };
    const githubAuthRequest = await this.datasourceService.createGithubAuthRequest(request).toPromise();
    const callbackUrl = this.visiableGithubAppInfo ? `${baseUrl}/api/platform/datasources/github?state=${githubAuthRequest.id}` : `http://github-app.oobeya.io/api/github/callback?environment=${baseUrl}&state=${githubAuthRequest.id}`;
    window.location.href = this.visiableGithubAppInfo ? `https://github.com/login/oauth/authorize?client_id=${clientId}&redirect_uri=${callbackUrl}` : `https://github.com/login/oauth/authorize?client_id=${oobeyaClientId}&redirect_uri=${callbackUrl}`;
  }

  copyToken(text: string) {
    navigator.clipboard.writeText(text);
  }

  renderAuthTokenType() {
    const isBearer=this.addForm?.get('authInfo')?.get('authTokenType')?.value !=='BEARER'
    if(isBearer){
      this.addForm?.get('authInfo')?.get('username')?.clearValidators();
    }
    return isBearer
  }

  testConnection(): void {
    // validateFormGroup(this.addForm);
    // if (this.addForm.invalid) {
    //   return;
    // }

    const {id,addonId, url, authType, authInfo, version} = this.addForm.value;

    const connectData = {id,url, authInfo, authType, addonId, version};

    this.customEventService.announceEvent(ActionTypesEnum.TEST_CONNECTION, connectData);
    this.testConnectionDone = true;
  }
}
